var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDarAchieved = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 24,
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12.667,
  cy: 12,
  r: 12,
  fill: "url(#paint0_linear_47687_220807)"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.6667 5.3335C9 5.3335 6 8.3335 6 12.0002C6 15.6668 9 18.6668 12.6667 18.6668C16.3333 18.6668 19.3333 15.6668 19.3333 12.0002C19.3333 8.3335 16.3333 5.3335 12.6667 5.3335ZM15.4667 10.8668L12.2667 14.0668C12 14.3335 11.6 14.3335 11.3333 14.0668L9.86667 12.6002C9.6 12.3335 9.6 11.9335 9.86667 11.6668C10.1333 11.4002 10.5333 11.4002 10.8 11.6668L11.8 12.6668L14.5333 9.9335C14.8 9.66683 15.2 9.66683 15.4667 9.9335C15.7333 10.2002 15.7333 10.6002 15.4667 10.8668Z",
  fill: "white"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_47687_220807",
  x1: 7.16699,
  y1: 1,
  x2: 16.667,
  y2: 23,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EED79C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFB7A0"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDarAchieved);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dar_achieved.8e7e4a4636375f99e1091789c03ecc99.svg";